import React from "react";

import { useIntl } from "react-intl";

import { aiConfigItemMessages } from "@atlaskit/editor-common/ai-messages";
import { ToolbarDropdownItem } from "@atlaskit/editor-toolbar";
import AiGenerativeRemixIcon from "@atlaskit/icon-lab/core/ai-generative-remix";

type RemixPasteMenuItemProps = {
	onClick: () => void;
};

export const RemixPasteMenuItem = ({ onClick }: RemixPasteMenuItemProps): JSX.Element => {
	const intl = useIntl();
	return (
		<ToolbarDropdownItem
			testId="ai-paste-menu__remix"
			elemBefore={<AiGenerativeRemixIcon size="small" label="" />}
			onClick={onClick}
		>
			{intl.formatMessage(aiConfigItemMessages.remixTitle)}
		</ToolbarDropdownItem>
	);
};
